import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import {
  isDarkAuthShellPath,
  isLightAuthShellPath,
} from "@/lib/is-navy-auth-shell-path";

const STORAGE_KEY = "gestionalo.portal.theme";

export function PortalThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  const { pathname } = useLocation();
  const forcedTheme = isLightAuthShellPath(pathname)
    ? "light"
    : isDarkAuthShellPath(pathname)
      ? "dark"
      : undefined;

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey={STORAGE_KEY}
      forcedTheme={forcedTheme}
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  );
}
